var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import clsx from 'clsx';
import Typography from '../Typography';
import SvgClose from '../Icon/SvgClose';
import ButtonIcon from '../Button/ButtonIcon';
import { rem } from '../utils/Polished';
import { withForwardedRef } from '../utils/helpers/reactHelpers';
const PopupTitleSC = styled.div `
  padding: 0;
  flex: 0 0 auto;
  min-height: ${rem('32px')};
  display: flex;
  align-items: center;

  ._ndsPopupTitle__text {
    align-self: flex-start;
    margin-top: ${rem('4px')};
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: auto;
  }
  ._ndsPopupTitle__close {
    align-self: flex-start;
    margin-right: ${rem('-4px')};
    min-width: ${rem('32px')};
  }
  ._ndsPopupTitle__close--dark-mode {
    cursor: pointer;
  }
`;
const PopupTitle = (props) => {
    const { children, forwardedRef, onClose, className: classNameProp, responsive, darkMode } = props, others = __rest(props, ["children", "forwardedRef", "onClose", "className", "responsive", "darkMode"]);
    const hasCloseAction = typeof onClose === 'function';
    const renderChildren = React.useMemo(() => responsive ? (React.createElement(React.Fragment, null,
        React.createElement(Typography, Object.assign({ variant: "h5", className: "ndsHidden-s-up" }, (darkMode && { mode: 'dark' })), children),
        React.createElement(Typography, Object.assign({ variant: "h3", className: "ndsHidden-xs-down" }, (darkMode && { mode: 'dark' })), children))) : (React.createElement(Typography, Object.assign({ variant: "h6", className: "_ndsPopupTitle__text" }, (darkMode && { mode: 'dark' })), children)), [responsive, children, darkMode]);
    if (children) {
        return (React.createElement(PopupTitleSC, Object.assign({ ref: forwardedRef, className: clsx(classNameProp, '_ndsPopupTitle', {
                '_ndsPopupTitle--with-close': hasCloseAction
            }) }, others),
            renderChildren,
            hasCloseAction && !darkMode && (React.createElement(ButtonIcon, Object.assign({ onClick: onClose, className: "_ndsPopupTitle__close" }, (!darkMode && { color: 'grey' }), { compact: true }),
                React.createElement(SvgClose, null))),
            hasCloseAction && darkMode && (React.createElement(SvgClose, { onClick: onClose, className: "_ndsPopupTitle__close--dark-mode", color: "#ffffff" }))));
    }
    return null;
};
PopupTitle.propTypes = {
    children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    forwardedRef: PropTypes.any,
    onClose: PropTypes.func,
    className: PropTypes.string,
    responsive: PropTypes.bool,
    darkMode: PropTypes.bool
};
PopupTitle.defaultProps = {
    children: null,
    forwardedRef: React.createRef(),
    onClose: null,
    className: undefined,
    responsive: false,
    darkMode: false
};
export default withForwardedRef(PopupTitle);
//# sourceMappingURL=PopupTitle.js.map